export * from './regInfoDossier.component';
